import { $t } from '@/i18n';
import { notification } from 'ant-design-vue';
import { message } from '@/utils/wuji-message';
export class FormCallResult {
    items;
    type = 'success';
    message = '';
    get failDesc() {
        if (this.type === 'success') {
            return '';
        }
        const failureItems = this.items.filter(item => !item.succ);
        const desc = failureItems.map(item => $t('k_e8048190', { arg_0: item.bizId, arg_1: item.message })).join(';\n');
        return desc;
    }
    constructor(items) {
        this.items = items;
        const successCount = items.filter(item => item.succ).length;
        if (successCount === items.length) {
            this.type = 'success';
            this.message = $t('k_b32f7432');
            return;
        }
        if (successCount > 0 && successCount < items.length) {
            this.type = 'partial';
            this.message = $t('k_e08533af');
            return;
        }
        this.type = 'fail';
        this.message = $t('k_2b870b4b');
    }
    showMessage() {
        if (this.type === 'success') {
            message.success(this.message);
            return;
        }
        notification.open({
            message: this.message,
            description: this.failDesc,
        });
    }
}
